import { render, staticRenderFns } from "./platformPlaystation.vue?vue&type=template&id=d5a3be14&"
import script from "./platformPlaystation.vue?vue&type=script&lang=js&"
export * from "./platformPlaystation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports